module.exports = __webpack_public_path__ + "static/media/warning.dda0d8ae.webp";